import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useSearchParams } from "react-router-dom";
import isEmpty from "lodash-es/isEmpty";
import Alert from "@mui/material/Alert";

import { ReactComponent as AttachFileIcon } from "../../icons/AttachFile24.svg";
import IconButton from "@mui/material/IconButton";

import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import dayjs from "dayjs";
import clone from "lodash-es/clone";

import Link from "@mui/material/Link";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Title from "../../components/Title";

import DrawerAppBar from "../../components/DrawerAppBar";
import SubTitle from "../../components/SubTitle";
import ProgressBar from "../../components/ProgressBar";
import { getUserEid } from "../../services/UserService";
import {
  getSchoolPendingServices,
  removeCommServices,
  adminGetCommServiceDownloadUrl,
  downloadFile,
  sendStudentReminder,
  updateCommServiceAttribute,
  getCommServiceReviewers,
  getStudentStatusTotals,
} from "../../services/CommServiceService";

import {
  StripedTableRow,
  StripedTableCell,
} from "../../components/StripedTable";
import { doService } from "../../services/ServiceHelper";

import TableRowNoResults from "../../components/TableRowNoResults";
import CommServiceTotalsDialog from "../../components/admin/CommServiceTotalsDialog";
import CommServiceDetailsDialog from "../../components/admin/CommServiceDetailsDialog";
import {
  showError,
  showOKCancelDialog,
  showToast,
} from "../../components/ATPDialogs";

const OpsByGrade = () => {
  const [_jwt] = useJwtStorage();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_showProgress, setShowProgress] = useState(false);
  const [_ops, setOps] = useState([]);
  const [_selectedCommItem, setSelectedCommItem] = useState({
    hourNum: 0,
    minuteNum: 0,
  });
  const [_commDialogOpen, setCommDialogOpen] = useState(false);
  const [_grade, setGrade] = useState([]);
  const [queryParams] = useSearchParams();
  const [_reviewers, setReviewers] = useState([]);

  const [_totalsDialogOpen, setTotalsDialogOpen] = useState(false);

  const [_student, setStudent] = useState({});
  const [_studentTotals, setStudentTotals] = useState({});
  const [_studentOps, setStudentOps] = useState([]);
  const [_isReviewer, setReviewer] = useState(false);

  /**
   * returns true if the current user is a reviewer, which allows them to modify settings
   */
  const initReviewers = () => {
    doService(getCommServiceReviewers(_school, _jwt), (results) => {
      setReviewers(results.data);
    });
  };

  useEffect(() => {
    const grade = queryParams.get("grade");
    setGrade(grade);
    reloadPendingServices();
    initReviewers();
  }, []);

  const reloadPendingServices = () => {
    const grade = queryParams.get("grade");
    initPendingServices(grade);
  };

  const initPendingServices = (grade) => {
    setShowProgress(true);
    doService(getSchoolPendingServices(_school, _jwt, grade), (result) => {
      setShowProgress(false);

      const typeMap = {};
      for (const type of result.data.types) {
        typeMap[type.eid] = type;
      }

      const studentTypeTotalsMap = result.data.student_type_totals;
      for (const item of result.data.services) {
        item.isChecked = false;
        if (item.reviewerEid === null) {
          item.reviewerEid = "XX";
        }

        const key = `${item.studentEid}_${item.typeEid}`;
        item.typeNameColor = "black";
        item.yearlyHours = 0;
        item.allHours = 0;

        let yearlyMaxHours = 0;

        if (typeMap[item.typeEid]) {
          yearlyMaxHours = typeMap[item.typeEid].yearlyMaxHours;
        }
        item.yearlyHours = yearlyMaxHours;

        if (studentTypeTotalsMap[key]) {
          const allHoursTotal = studentTypeTotalsMap[key]["allHoursTotal"];

          item.allHours = allHoursTotal;
          if (allHoursTotal >= yearlyMaxHours) {
            item.typeNameColor = "red";
          }
        }
      }
      setOps(result.data.services);
    });
  };

  const onClickItem = (item) => {
    setSelectedCommItem(item);
    setCommDialogOpen(true);
  };

  const doUpdateSelectedItem = (hourNum, minuteNum) => {
    const item = clone(_selectedCommItem);
    item.hourNum = hourNum;
    item.minuteNum = minuteNum;
    setSelectedCommItem(item);
  };

  const onApprove = () => {
    reloadPendingServices();
    setSelectedCommItem({});
  };

  const onReject = () => {
    reloadPendingServices();
    setSelectedCommItem({});
  };

  const onDelete = () => {
    reloadPendingServices();
    setSelectedCommItem({});
  };

  const onChange = (type, value) => {
    setShowProgress(true);
    doService(
      updateCommServiceAttribute(
        _school,
        _jwt,
        _selectedCommItem.eid,
        type,
        value,
      ),
      (result) => {
        setShowProgress(false);
        showToast("S", "Service Updated.");
        reloadPendingServices();
      },
    );
  };

  const handleChangeChecked = (event, opEid) => {
    const ops = clone(_ops);

    for (const op of ops) {
      if (op.eid === opEid) {
        op.isChecked = event.target.checked;
        break;
      }
    }

    setOps(ops);
  };

  const handleChangeReviewer = (event, opEid) => {
    const ops = clone(_ops);

    let reviewerEid = "XX";
    for (const op of ops) {
      // found the op to update
      if (op.eid === opEid) {
        if (event.target.value === "ME") {
          op.reviewerEid = getUserEid(_jwt);
          reviewerEid = getUserEid(_jwt);
        } else if (event.target.value === "XX") {
          op.reviewerEid = "XX";
          reviewerEid = "XX";
        } else {
          op.reviewerEid = event.target.value;
          reviewerEid = event.target.value;
        }
      }
    }

    updateCommServiceAttribute(
      _school,
      _jwt,
      opEid,
      "reviewerEid",
      reviewerEid === "XX" ? null : reviewerEid,
    );
    setOps(ops);
  };

  const onClickDeleteSelected = () => {
    const opEids = [];

    for (const op of _ops) {
      if (op.isChecked) {
        opEids.push(op.eid);
      }
    }

    if (opEids.length === 0) {
      showError("Unable to Delete", "Please select 1 or more Service Ops.");
      return;
    }

    showOKCancelDialog(
      "Delete Service Op(s)",
      `Click OK to delete ${opEids.length} service op(s).`,
      () => {
        setShowProgress(true);
        doService(removeCommServices(_school, _jwt, opEids), (results) => {
          setShowProgress(false);
          showToast("S", "Service Op(s) Deleted");
          initPendingServices(_grade);
        });
      },
    );
  };

  const onClickSendReminder = (op) => {
    setShowProgress(true);
    doService(sendStudentReminder(_school, _jwt, op.eid), (results) => {
      setShowProgress(false);
      showToast("S", "Email(s) Sent");
    });
  };

  const onClickDownloadFile = (op) => {
    doService(
      adminGetCommServiceDownloadUrl(_school, _jwt, op.eid),
      (result) => {
        downloadFile(op.originalFilename, result.data);
      },
    );
  };

  const onClickStudent = (student) => {
    setShowProgress(true);
    doService(
      getStudentStatusTotals(_school, _jwt, student.studentEid),
      (result) => {
        setShowProgress(false);
        setStudent(result.data.student);
        setStudentTotals(result.data.totals);
        setStudentOps(result.data.ops);
        setTotalsDialogOpen(true);
      },
    );
  };

  const getLinkStyle = (result) => {
    if (result.isDonation === "N") {
      return {
        color: "black",
        fontWeight: 800,
        textAlign: "left",
      };
    }
    switch (result.status) {
      case 100:
        return { color: "green", fontWeight: 800, textAlign: "left" };
      case -100:
        return { color: "purple", fontWeight: 500, textAlign: "left" };
      default:
        return { color: "black", fontWeight: 800, textAlign: "left" };
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text={`Pending Service Ops for ${_grade}`} />
        <ProgressBar showProgress={_showProgress} />
        <Alert severity="info">
          Click on the student name for student grand totals.
        </Alert>
        <br />

        <SubTitle text={`Pending Service Op List (${_ops.length})`} />
        <Grid container>
          <Grid item xs={6}></Grid>
          <Grid item xs={6} sx={{ textAlign: "right" }}>
            <Button variant="outlined" onClick={onClickDeleteSelected}>
              Delete Selected
            </Button>
          </Grid>
        </Grid>
        <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
          <Table size="small">
            <TableHead>
              <StripedTableRow>
                <StripedTableCell align="center">Select</StripedTableCell>
                <StripedTableCell align="center">Review</StripedTableCell>
                <StripedTableCell>Entry</StripedTableCell>
                <StripedTableCell>Student Name</StripedTableCell>
                <StripedTableCell>Type</StripedTableCell>
                <StripedTableCell align="center">Verification</StripedTableCell>
                <StripedTableCell align="center">Reminder</StripedTableCell>
              </StripedTableRow>
            </TableHead>
            <TableBody>
              <TableRowNoResults data={_ops} />
              {_ops.map((op) => (
                <StripedTableRow key={op.eid}>
                  <StripedTableCell align="center">
                    <Checkbox
                      sx={{ pt: 0 }}
                      checked={op.isChecked}
                      className="chkPresent"
                      onChange={(event) => handleChangeChecked(event, op.eid)}
                    />
                  </StripedTableCell>
                  <StripedTableCell>
                    <Select
                      fullWidth
                      size="small"
                      onChange={(event) => handleChangeReviewer(event, op.eid)}
                      value={op.reviewerEid}
                      sx={{ mb: 1 }}
                    >
                      <MenuItem key="XX" value="XX">
                        -- NONE --
                      </MenuItem>
                      <MenuItem key="ME" value="ME">
                        -- ME --
                      </MenuItem>
                      {_reviewers.map((reviewer) => (
                        <MenuItem
                          key={reviewer.userEid}
                          value={reviewer.userEid}
                        >
                          {reviewer.last_name}, {reviewer.first_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </StripedTableCell>
                  <StripedTableCell>
                    <Link
                      component="button"
                      onClick={() => {
                        onClickItem(op);
                      }}
                      style={{ fontWeight: "800" }}
                    >
                      {op.eventDateStart !== op.eventDateEnd && (
                        <>
                          {dayjs(op.eventDateStart).format("MM/DD")} -{" "}
                          {dayjs(op.eventDateEnd).format("MM/DD")}
                        </>
                      )}
                      {op.eventDateStart === op.eventDateEnd && (
                        <>for {dayjs(op.eventDateStart).format("MM/DD/YY")}</>
                      )}
                    </Link>
                    <br />
                    Submitted {dayjs(op.dateCreated).format("MM/DD/YY hh:mm")}
                  </StripedTableCell>

                  <StripedTableCell>
                    <Link
                      component="button"
                      onClick={() => {
                        onClickStudent(op);
                      }}
                      sx={getLinkStyle(op)}
                    >
                      {op.studentLastName}, {op.studentFirstName} ({op.grade})
                    </Link>
                  </StripedTableCell>
                  <StripedTableCell sx={{ color: op.typeNameColor }}>
                    <Tooltip
                      title={
                        <>
                          Current Hours: {Math.round(op.allHours * 10) / 10}
                          <br />
                          Max Yearly Hours: {op.yearlyHours}
                        </>
                      }
                    >
                      {op.typeName}
                      {!isEmpty(op.originalFilename) && (
                        <IconButton
                          size="small"
                          title="attached document"
                          onClick={() => onClickDownloadFile(op)}
                        >
                          <AttachFileIcon />
                        </IconButton>
                      )}
                    </Tooltip>
                  </StripedTableCell>
                  <StripedTableCell align="center">
                    {op.status === 50 && (
                      <>
                        <Chip label="N/A" />
                      </>
                    )}
                    {op.status !== 50 && (
                      <>
                        {op.verifierStatus === 0 && (
                          <Chip label="PENDING" color="warning" />
                        )}
                        {op.verifierStatus === -100 && (
                          <Chip label="REJECTED" color="error" />
                        )}
                        {op.verifierStatus === 100 && (
                          <Chip label="VERIFIED" color="secondary" />
                        )}
                      </>
                    )}
                  </StripedTableCell>
                  <StripedTableCell align="center" nowrap>
                    {op.reminderCount === 0 && (
                      <>
                        <Chip color="error" label="NOT SENT" />
                      </>
                    )}
                    {op.reminderCount > 0 && (
                      <>
                        <Chip color="success" label="SENT" />
                      </>
                    )}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        onClickSendReminder(op);
                      }}
                      sx={{ ml: 2 }}
                    >
                      Send
                    </Button>
                  </StripedTableCell>
                </StripedTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <CommServiceDetailsDialog
        school={_school}
        jwt={_jwt}
        dialogOpen={_commDialogOpen}
        setDialogOpen={setCommDialogOpen}
        doUpdateSelectedItem={doUpdateSelectedItem}
        selectedItem={_selectedCommItem}
        onApprove={onApprove}
        onReject={onReject}
        onDelete={onDelete}
        onChange={onChange}
      />

      <CommServiceTotalsDialog
        student={_student}
        totals={_studentTotals}
        ops={_studentOps}
        dialogOpen={_totalsDialogOpen}
        setDialogOpen={setTotalsDialogOpen}
      />

    </>
  );
};

export default OpsByGrade;
